<template>
  <div class="attachments-list">
    <div v-for="attachment in attachments" :key="attachment.id">
      <Attachment :item="attachment"></Attachment>
    </div>
  </div>
</template>

<script>
import Attachment from 'CORE/components/attachment/attachment'

export default {
    name: 'AttachmentsList',
    components: {
        Attachment,
    },
    props: {
        attachments: {
            default: {},
        },
    },
}
</script>

<style lang="scss" scoped>
.attachments-list {
    & > div {
        margin: 3px;
    }
    & > div:nth-child(odd) {
        background-color: rgba(0,0,0,0.05);
    }
}
</style>
